import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import formatCnpj from '@brazilian-utils/format-cnpj';
import { useDispatch, useSelector } from 'react-redux';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import EconomicGroup from '~/components/pages/Portal/EconomicGroup';
import iconRevenda from '~/assets/images/Header/ic_revenda.svg';
import '~/components/styles/Global.css';

import {
  Container,
  ResaleContainer,
  ResaleContent,
  ReleaseIcon,
  ReleaseInfo,
  DesktopWrapper,
  MobileWrapper,
  ColorIconDesktop,
} from './styles';

function Header({ stores, disabledOnMobile, modeSimple }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const expand = useSelector(state => state.economicGroupReducer.expand);
  const economicGroupReducer = useSelector(state => state.economicGroupReducer);
  const userReducer = useSelector(state => state.userReducer);

  const [storeName, setStoreName] = useState('');
  const [storeDocument, setStoreDocument] = useState('');
  const storeDocumentLocal = window.location.pathname === "/lapidar/ciclo-de-apuracao/adicaoRevenda" ?
  localStorage.getItem('storeDocumentLapidar') : localStorage.getItem('storeDocument');
  useEffect(() => {
    dispatch({ type: 'SET_EXPAND', expand: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setStoreName(window.location.pathname === "/lapidar/ciclo-de-apuracao/adicaoRevenda" ? 
    localStorage.getItem('storeNameLapidar') : localStorage.getItem('storeName'));
    setStoreDocument(window.location.pathname === "/lapidar/ciclo-de-apuracao/adicaoRevenda" ?
    localStorage.getItem('storeDocumentLapidar') : localStorage.getItem('storeDocument'));
  }, [userReducer.response, storeDocumentLocal]);

  return (
    <Container disabledOnMobile={disabledOnMobile}>
      <DesktopWrapper>
        <ResaleContainer>
          <EconomicGroup stores={stores} mobile={false}>
            <ResaleContent expand={economicGroupReducer.expand}>
              <ReleaseIcon src={iconRevenda} alt="icone revenda" />
              <ReleaseInfo color="#000FFF">
                {storeName} - CNPJ: {formatCnpj(storeDocument)}
              </ReleaseInfo>
              {expand ? (
                <ExpandLessIcon style={ColorIconDesktop} />
              ) : (
                <ExpandMoreIcon style={ColorIconDesktop} />
              )}
            </ResaleContent>
          </EconomicGroup>
        </ResaleContainer>
      </DesktopWrapper>
      <MobileWrapper>
        <ResaleContainer>
          <EconomicGroup stores={stores} mobile={true} lapidar={true}>
            <ResaleContent expand={economicGroupReducer.expand}>
              <ReleaseIcon src={iconRevenda} alt="icone revenda" />
              <ReleaseInfo color="#000FFF">
                {storeName} - CNPJ: {formatCnpj(storeDocument)}
              </ReleaseInfo>
              {expand ? (
                <ExpandLessIcon style={ColorIconDesktop} />
              ) : (
                <ExpandMoreIcon style={ColorIconDesktop} />
              )}
            </ResaleContent>
          </EconomicGroup>
        </ResaleContainer>
      </MobileWrapper>
    </Container>
  );
}

export default Header;
